import React from 'react';

import linkedinIcon from './img/svg/linkedin_icon.svg';
import facebookIcon from './img/svg/facebook_icon.svg';
import xIcon from './img/svg/x_icon.svg';
import printIcon from './img/svg/print_icon.svg';
import emailIcon from './img/svg/email_icon.svg';

const buttonAttributes = [
  [linkedinIcon, 'Linkedin', 'post', 't-article-end-social-linkedin'],
  [facebookIcon, 'Facebook', 'share', 't-article-end-social-facebook'],
  [xIcon, 'X', 'post', 't-article-end-social-twitter'],
  [printIcon, 'Print', 'print', 'js-social-button-print'],
  [emailIcon, 'Email', 'email', 't-article-end-social-email'],
];

const SocialIcons = () => {
  return (
    <div className="social-share">
      <ul className="social-icon-list">
        { buttonAttributes.map(([svg, alt, text, trackingClass]) => (
          <li key={alt}>
            <button type="button" className={`social-icon social-icon--disabled ${trackingClass}`}>
              <img className="social-icon__icon" src={svg} alt={`Disabled ${alt} button preview`} />
              <span className="social-icon__text">{text}</span>
            </button>
          </li>
        )) }
      </ul>
    </div>
  );
};

export default SocialIcons;
